import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ActivateApplicantAccount.css';
import ConfirmPassword from '../../confirmPassword/ConfirmPasswordActivation.container';
import FormWrapper from '../../../commonComponents/formWrapper/FormWrapper.container';
import { Button, Form, FormGroup, Label, Col, Input } from 'reactstrap';
import _ from 'lodash';
import { sharedLabelsPath } from "../../../../reducers/common/localization";
import { Utils } from './../../../../utils/utils';

class ActivateApplicantAccount extends Component {
    constructor(props) {
        super(props);
        this.state = {
            password: '',
            passwordConfirm: ''
        };
    }

    render() {        
        return (
            <div className="activation-applicant-container">
                <h4 className='text-center'>{_.get(this.props.translation, 'activation.label')}</h4>
                <FormWrapper
                    successMessage={_.get(this.props.translation, 'activation.activation_success_alert')}
                >
                    <Form onSubmit={this.onActivate}>
                        <h6>{_.get(this.props.translation, 'activation.activate_applicant_label')}</h6>
                        <FormGroup row>
                            <Label sm={3} >{_.get(this.props.translation, sharedLabelsPath.email_label)}</Label>
                            <Col sm={9}>
                                <Input type='text'
                                    value={this.props.email}
                                    disabled={true}
                                />
                            </Col>
                        </FormGroup>
                        <ConfirmPassword
                            handleChange={this.handleChange}
                            password={this.state.password}
                            passwordConfirm={this.state.passwordConfirm}
                        />
                        <div className="submit-activation-applicant-container">
                            <Button type="submit" className="olive-green-btn">{_.get(this.props.translation, 'activation.activate_button')}</Button>
                        </div>
                    </Form>
                </FormWrapper>
            </div>
        );
    }

    handleChange = (fieldKey) => (e) => {
        this.setState({ [fieldKey]: e.target.value });
    };

    onActivate = (e) => {
        e.preventDefault();
        if (this.state.password !== '' && this.state.password === this.state.passwordConfirm && Utils.isValidPassword(this.state.password)) {

            let data = {
                password: this.state.password
            };

            this.props.onActivate(this.props.token, data);
        }
    };
}

ActivateApplicantAccount.propTypes = {
    email: PropTypes.string,
    token: PropTypes.string,
    translation: PropTypes.object.isRequired,
    onActivate: PropTypes.func.isRequired
};

export default ActivateApplicantAccount;



// WEBPACK FOOTER //
// ./src/components/accountManagement/activateUserAccount/activateApplicantAccount/ActivateApplicantAccount.js